import { Component, OnInit, Input, ElementRef } from '@angular/core';

import { gsap } from 'gsap';

@Component({
    selector: '[aaToggleSwitch]',
    templateUrl: './toggle-switch.component.html',
    styleUrls: [
        './toggle-switch.component.scss'
    ],
    standalone: false
})
export class ToggleSwitchComponent implements OnInit
{
    @Input() posX: number = 0;
    @Input() posY: number = 0;
    @Input() toggle: boolean = true;
    @Input() label: string = '';
    @Input() clickToggle: () => void;
    private myCircle;
    private myPath;

    constructor (private elementRef: ElementRef)
    { }

    ngOnInit ()
    {
        this.myCircle = this.elementRef.nativeElement.querySelector('circle');
        this.myPath = this.elementRef.nativeElement.querySelector('path');
    }

    onClick ()
    {
        const tl = gsap.timeline();
        const duration: number = 0.5;

        if (this.toggle)
        {
            tl
                .to(this.myCircle, { duration: duration, cx: 75, ease: 'sine.in' }, 0)
                .to(this.myPath, { duration: duration, fill: '#ededed', ease: 'sine.in' }, 0);
        }
        else
        {
            tl
                .to(this.myCircle, { duration: duration, cx: 25, ease: 'sine.out' }, 0)
                .to(this.myPath, { duration: duration, fill: '#0057ff', ease: 'sine.out' }, 0);
        }

        this.clickToggle();
    }
}
